const focusOnFirstElement = (node)=>{
    setTimeout(()=>{
        node.querySelector('button:not(.btn-close):not([disabled]):not([readonly]), [href], input:not([disabled]):not([readonly]), select:not([disabled]):not([readonly]), textarea:not([disabled]):not([readonly]), [tabindex]:not(.disabled):not(.readonly):not([tabindex="-1"])')?.focus();
    }, 250);
};
const focusOnLastElement = (node)=>{
    setTimeout(()=>{
        const elements = node.querySelectorAll('button:not(.btn-close):not([disabled]):not([readonly]), [href], input:not([disabled]):not([readonly]), select:not([disabled]):not([readonly]), textarea:not([disabled]):not([readonly]), [tabindex]:not(.disabled):not(.readonly):not([tabindex="-1"])');
        elements[elements.length - 1]?.focus();
    }, 250);
};
const isFocusableInput = (input)=>{
    if (typeof input?.focus === "function") {
        const hiddenInput = input.closest(".form-control")?.querySelector(`.select__control+input[type="hidden"]`);
        if (hiddenInput) {
            hiddenInput.setAttribute("type", "text");
            hiddenInput.style.height = "0px";
            hiddenInput.style.position = "fixed";
            hiddenInput.style.top = "-100px";
            hiddenInput.style.right = "-100px";
            setTimeout(()=>{
                hiddenInput.setAttribute("type", "hidden");
            }, 1000);
        }
        return true;
    }
    return false;
};

export { focusOnFirstElement, focusOnLastElement, isFocusableInput };
//# sourceMappingURL=focus.js.map
